<template>
	<div id="loginbox">
		<Toptab/>
		<div class="bg-login">
			<div class="bg-login2">
				<p class="topname">西安航装电子科技有限公司</p>
				<div class="logintable">
					<div class="login-logo">
						<router-link to="Index">
							<img src="../assets/img/logo-2.png" >
						</router-link>
						<!-- <a href="./index.vue">
							
						</a> -->
						
					</div>
					<div class="inpbox name"><img src="../assets/img/user.svg">
						<input placeholder="用户名" type="text">
					</div>
					<div class="inpbox password">
						
						<input placeholder="密码" type="text">
					</div>
					<div class="login-else">
						<a href="#" ><span>忘记密码</span></a>
						<!-- <a href="#" ><span>注册</span></a> -->
						<router-link to="Reg">
							<span>注册</span>
						</router-link>
						
					</div>
					
					<div class="likelog">
						<span>立即登录</span>
					</div>
					
					<div class="nothing">
						<span class="lef"></span> <span class="other">使用第三方账号登录</span><span class="rig"></span>
					</div>
					
					<div class="methods">
						<img src="../assets/img/qq_1.svg" >
						<img src="../assets/img/weixinlogo.png" >
						<img src="../assets/img/weibologo.png" >
						
					</div>
				</div>
				<p class="footname"><span>Copyright &copy; 2021.西安航装电子科技有限公司 All rights reserved.</span></p>
			</div>
			
		</div>
	</div>
	
</template>

<script>
	import Toptab from '../components/toptab.vue'
	export default {
		components: {
			Toptab,
		},
	}
</script>

<style scoped>
	@import url("../assets/css/commen.css");
	@import url("../assets/css/login.css");
</style>
